// Hash routing: URLs look like /#/entry/dict_000089
// This requires zero server-side redirect configuration and avoids
// Cloudflare Pages' infinite-loop detection on /* /index.html rules.
import { createHashRouter, RouterProvider } from 'react-router-dom'
import { SearchPage } from './pages/SearchPage'
import { EntryPage }  from './pages/EntryPage'
import { AdminPage }  from './pages/AdminPage'
import { AboutPage }  from './pages/AboutPage'

const router = createHashRouter([
  { path: '/',               element: <SearchPage /> },
  { path: '/entry/:entryId', element: <EntryPage /> },
  { path: '/admin',          element: <AdminPage /> },
  { path: '/about',          element: <AboutPage /> },
  { path: '*',               element: <SearchPage /> },
])

export default function App() {
  return <RouterProvider router={router} />
}
